(function () {
  'use strict';

  function init(menu) {
    if (!menu || menu.dataset.lnUnifiedMenu === 'true') return;
    menu.dataset.lnUnifiedMenu = 'true';
    var trigger = menu.querySelector(':scope > summary');
    var panel = menu.querySelector(':scope > nav');
    var header = menu.closest('.ln10-header');
    if (!trigger || !panel || !header) return;

    function position() {
      panel.style.setProperty('--ln-menu-top', Math.max(0, header.getBoundingClientRect().bottom) + 'px');
    }
    function sync() {
      trigger.setAttribute('aria-label', menu.open ? 'Luk navigation' : 'Åbn navigation');
      trigger.setAttribute('aria-expanded', menu.open ? 'true' : 'false');
      var label = trigger.querySelector('.ln10-menu-label');
      if (label) label.textContent = menu.open ? 'Luk' : 'Menu';
      if (menu.open) position();
    }
    function close(restoreFocus) {
      menu.open = false;
      if (restoreFocus) trigger.focus({ preventScroll: true });
    }
    menu.addEventListener('toggle', sync);
    menu.querySelectorAll('a').forEach(function (link) {
      if (link.hasAttribute('data-ln-menu-jump')) {
        link.addEventListener('click', function (event) {
          var target = document.getElementById(link.hash.slice(1));
          if (!target || !panel.contains(target)) return;
          event.preventDefault();
          target.scrollIntoView({ block: 'start' });
          target.focus({ preventScroll: true });
        });
        return;
      }
      if (link.pathname === window.location.pathname && !link.hash && !link.search) {
        link.setAttribute('aria-current', 'page');
      }
      link.addEventListener('click', function (event) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        close(true);
      });
    });
    document.addEventListener('keydown', function (event) {
      if (!menu.isConnected || !menu.open) return;
      if (event.key === 'Escape') { event.preventDefault(); close(true); return; }
      if (event.key !== 'Tab') return;
      var items = Array.from(menu.querySelectorAll('summary, a[href], input:not([disabled]), button:not([disabled])')).filter(function (node) {
        return node.tabIndex >= 0 && node.getClientRects().length > 0;
      });
      var first = items[0], last = items[items.length - 1];
      if (!first) return;
      if (event.shiftKey && (document.activeElement === first || !menu.contains(document.activeElement))) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !menu.contains(document.activeElement))) {
        event.preventDefault(); first.focus();
      }
    });
    document.addEventListener('click', function (event) {
      if (menu.isConnected && menu.open && !menu.contains(event.target)) close(false);
    });
    window.addEventListener('resize', function () { if (menu.isConnected && menu.open) position(); }, { passive: true });
    window.addEventListener('pageshow', function () { if (menu.isConnected) close(false); });
    sync();
  }
  function boot() { document.querySelectorAll('.ln10-header__mobile-menu').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
